module.exports = __webpack_public_path__ + "static/media/rebirth_21.c53a0684.jpg";